import Vue from 'vue'
import Router from 'vue-router'

import store from '@/store'

import routerData from './router_data'
// import { geyPageByRole } from './role_page'

Vue.use(Router)

const fmRouter = new Router(routerData)

let testNeedAuth = function (router) {
  // 进入的页面是否需要登录
  return !router.path.includes('map_view') && !router.path.includes('no_permission_page') && !router.path.includes('login') && router.name !== 'test' && router.name !== 'auth' && !router.path.includes('/intranet_enter')
}

let testAuthPass = function () {
  // 用户是否已经登录
  // 可以加上用户是否有权限访问
  return store.getters.authPass
}

fmRouter.beforeEach((to, from, next) => {
  // 让分公司账号进入内网
  // if (location.href.includes('cnpc.test.eloop.pro') &&
  //   store.getters.userInfo &&
  //   (
  //     (
  //       store.getters.userInfo.currentRole && // 有分公司角色则根据分公司角色判断
  //       store.getters.userInfo.currentRole.name &&
  //       store.getters.userInfo.currentRole.name.includes('销售分公司')
  //     ) || (
  //       store.getters.userInfo.name && // 否则根据名字判断
  //       store.getters.userInfo.name.includes('分公司')
  //     )
  //   ) &&
  //   !to.path.includes('intranet_enter')) {
  //   next({name: 'intranet_enter'})
  if (testNeedAuth(to)) {
    if (testAuthPass()) {
      next()
      // let rolePage = geyPageByRole(to)
      // if (rolePage.pass) {
      //   next()
      // } else {
      //   next(rolePage.router)
      // }
    } else {
      // 用户未登录 记录目标url
      store.dispatch('setAuthBeforeRouter', to)
      next({name: 'auth'})
    }
  } else {
    next()
  }
})

export default fmRouter



// WEBPACK FOOTER //
// ./src/router/index.js